import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-divider',
  template: `
    <hr
      class="formly-divider"
      [class.light]="props['label']?.toLowerCase() === 'light'"
      [class.solid]="props['label']?.toLowerCase() === 'solid'" />
  `,
  styles: [
    `
      .formly-divider {
        border: none;
        border-top: 2px solid #000;
        margin: 1rem 0;
      }
      .formly-divider.light {
        border-color: #e0e0e0;
      }
      .formly-divider.solid {
        border-color: #000;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDividerComponent extends FieldType {}
